import { useMemo } from "react"

if (!("gtag" in window)) {
  ;(window as Window)["gtag"] = () => undefined
}

export const useGoogleAnalytics = () => {
  const track = (action: string, values: object) => {
    window.gtag("event", action, values)
  }

  const purchase = (values: object) => track("purchase", values)
  const pageView = (path: string, values: object) =>
    track("page_view", {
      page_path: path,
      page_title: window.document.title,
      ...values,
    })

  return useMemo(
    () => ({
      track,
      purchase,
      pageView,
    }),
    []
  )
}
